import { Nullable } from '../Nullable';
import { ArmyOrganisation } from './ArmyOrganisation';
import { MagicItem } from './magic-item';
import { MagicItemCategory } from './MagicItemCategory';
import { MagicStandard } from './magic-standard';
import { Organisation } from './Organisation';
import { Unit } from './Unit';
import { ModelRule } from './ModelRule';
import { ArmyVersioning } from './versioning/ArmyVersioning';
import { ModelRuleLimit } from './ModelRuleLimit';
import { MagicSpell } from './MagicSpell';

export interface Army extends ArmyVersioning {
  categoryId: number;
  nameWithSubVersion: string;
  initials: string;
  medium_logo: Nullable<string>;
  large_logo: Nullable<string>;
  units: Array<Unit>;
  modelRules: Array<ModelRule>;
  modelRuleLimits: Nullable<Array<ModelRuleLimit>>;
  magic_item_categories: Array<MagicItemCategory>;
  magic_items: Array<MagicItem>;
  magic_standards: Array<MagicStandard>;
  organisations: Array<Organisation>;
  army_organisations: Array<ArmyOrganisation>;
  spells: MagicSpell[];
  source: ArmySource;
  isLatest: boolean;
}

export enum ArmySource {
  Official = 0,
  Supplement = 1,
  FanMade = 2,
}
